import {
    UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN,
    UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS,
    UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE,
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';
  
const PATCHED_COMMENT_KEY  = "patchedComment";
const COMMENT_ID_PARAMETER = "commentId";

export function updateUploadedCommentsIsSarcasmManuallyToggled(props = {}) {
    return dispatch => {
        dispatch({
            type: UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN,
        });
        const url = `${apiEndPoints.comments.UPDATE_COMMENT_IS_SARCASM_MANUALLY_TOGGLED}?commentId=${props.commentId}&isSarcasmManuallyToggled=${props.isSarcasmManuallyToggled}`;
        const promise = new Promise((resolve, reject) => {
            const doRequest = http.patch(url);
            doRequest.then(
                res => {
                    dispatch({
                        type: UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS,
                        data: res.data,
                    });
                    resolve(res);
                },
                err => {
                    dispatch({
                        type: UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE,
                    });
                    reject(err);
                },
            );
        });
        return promise;
    };
}

export function reducer(state, action) {
    switch (action.type) {
        case UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN:
            return {
                ...state,
                updateUploadedCommentsIsSarcasmManuallyToggledBegin: true,
                updateUploadedCommentsIsSarcasmManuallyToggledSuccess: false,
                updateUploadedCommentsIsSarcasmManuallyToggledFailure: false,
                updateCrawledCommentsIsSarcasmManuallyToggledSuccess: false,
                updateCrawledCommentsIsSarcasmManuallyToggledFailure: false,
                updateTweetsIsSarcasmManuallyToggledSuccess: false,
                updateTweetsIsSarcasmManuallyToggledFailure: false,
                commentOrTweetAfterToggling: null
            };
        case UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS: {
            const updatedUploadedComments = state.allUploadedComments.data.map(comment => {
                if (comment.commentId === action.data.data[PATCHED_COMMENT_KEY][COMMENT_ID_PARAMETER]) {
                    comment = action.data.data[PATCHED_COMMENT_KEY];
                }
                return comment;
            });
            state.allUploadedComments.data = updatedUploadedComments;
            return {
            ...state,
            updateUploadedCommentsIsSarcasmManuallyToggledBegin: false,
            updateUploadedCommentsIsSarcasmManuallyToggledSuccess: true,
            commentOrTweetAfterToggling: action.data.data[PATCHED_COMMENT_KEY]
            };
        }
        case UPDATE_UPLOADED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE:
            return {
                ...state,
                updateUploadedCommentsIsSarcasmManuallyToggledBegin: false,
                updateUploadedCommentsIsSarcasmManuallyToggledFailure: true,
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/home/redux/updateUploadedCommentsIsSarcasmManuallyToggled.js